import * as React from 'react';
import { createPortal } from 'react-dom';

import { cn } from '../../lib/utils';

/** Dimming layer for every modal. Portalled to <body> so parent spacing can't offset it; z-50 sits above the z-40 app bar. */
export const modalScrimClassName =
    'fixed inset-0 z-50 m-0 flex items-center justify-center bg-black/40 p-4 animate-overlay-in';

/** Sheet material shared by modal panels; width, height and scrolling stay with each caller. */
export const modalSheetClassName = 'rounded-xl bg-white shadow-xl outline-none animate-sheet-in';

export function ModalOverlay({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) {
    return createPortal(
        <div className={cn(modalScrimClassName, className)}>{children}</div>,
        document.body,
    );
}
